import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface CaseStudyCardProps {
  id: string;
  title: string;
  client: string;
  category: string;
  description: string;
  imageUrl: string;
  featured?: boolean;
}

const CaseStudyCard: React.FC<CaseStudyCardProps> = ({
  id,
  title,
  client,
  category,
  description,
  imageUrl,
  featured = false,
}) => {
  return (
    <div 
      className={`group relative overflow-hidden rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl ${
        featured ? 'md:col-span-2 lg:col-span-2' : ''
      }`}
    >
      <div className="relative overflow-hidden aspect-video">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent opacity-70"></div>
        <div className="absolute top-4 left-4">
          <span className="inline-block px-3 py-1 rounded-full bg-blue-600 text-white text-xs font-medium">
            {category}
          </span>
        </div>
      </div>
      
      <div className="relative p-6 bg-white">
        <div className="mb-3">
          <span className="text-sm text-gray-500">{client}</span>
        </div>
        <h3 className="text-xl font-bold mb-3 text-gray-900 group-hover:text-blue-600 transition-colors duration-300">
          {title}
        </h3>
        <p className="text-gray-600 mb-6">
          {description.length > 150 ? `${description.substring(0, 150)}...` : description}
        </p>
        <Link 
          to={`/case-studies/${id}`} 
          className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-indigo-600 transition-colors duration-300"
        >
          View Case Study
          <ArrowRight className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-300" />
        </Link>
      </div>
    </div>
  );
};

export default CaseStudyCard;